var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebflowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2 0 0 2 0 -64)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 16,
    cy: 48,
    cx: 16,
    fill: "#4353ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7 46.1l-1.45 4.57c0-.35-1-7.93-1-7.93-2.3 0-3.52 1.63-4.16 3.36l-1.77 4.58c0-.33-.25-4.54-.25-4.54a3.74 3.74 0 0 0-3.63-3.39l1.88 11.48c2.4 0 3.7-1.63 4.37-3.36l1.5-3.9c0 .16 1 7.26 1 7.26A4.62 4.62 0 0 0 21.59 51l3.4-8.26c-2.4 0-3.66 1.63-4.3 3.36z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebflowIcon);
export default __webpack_public_path__ + "static/media/webflow-icon.6180beebaf2661ef6b8014009dd33bcb.svg";
export { ForwardRef as ReactComponent };